import { getAddress } from "viem"

export const vaults = new Map([
  [
    getAddress("0x49C077B74292aA8F589d39034Bf9C1Ed1825a608"),
    {
      name: "Euler Swell WETH",
      description:
        "A WETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x3C12AA52b014Acf7957308808362909b5757cca8"),
    {
      name: "Euler Swell wstETH",
      description:
        "A wstETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x10D0D11A8B693F4E3e33d09BBab7D4aFc3C03ef3"),
    {
      name: "Euler Swell weETH",
      description:
        "A weETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x4a5C95a0e3FCA4148F91cEb637fBA0E1080BE40e"),
    {
      name: "Euler Swell ezETH",
      description:
        "A ezETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x46e3c018798d6de4517A3c98358E4BD8D334B79C"),
    {
      name: "Euler Swell rsETH",
      description:
        "A rsETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xf34253Ec3Dd0cb39C29cF5eeb62161FB350A9d14"),
    {
      name: "Euler Swell swETH",
      description:
        "A swETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x1773002742A2bCc7666e38454F761CE8fe613DE5"),
    {
      name: "Euler Swell rswETH",
      description:
        "A rswETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0x29c85c752e854b0Cf2372e6B6c56f260755f5120"),
    {
      name: "Euler Swell pzETH",
      description:
        "A pzETH vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "euler-dao",
    },
  ],
  [
    getAddress("0xc5976e0356f0A3Ce8307fF08C88bB05933F88761"),
    {
      name: "Relend Network rUSDC",
      description:
        "A rUSDC vault collateralized by other vaults in the Euler Swell ETH cluster.",
      entity: "relend-network",
    },
  ],
])
